import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import type { Entity } from '@models/Entity'
import type { Page } from '@models/Query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchOpdrachtenForEntity,
  initialData,
} from '../services/fetchOpdrachtenForEntity'

export { useOpdrachtenForEntity }

const queryKey = 'entity-opdrachten'

const useOpdrachtenForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()
  const [page, setPage] = useState<Page>({
    skip: 0,
    limit: 25,
  })

  const { data, isFetching } = useQuery({
    queryFn: () => fetchOpdrachtenForEntity({ entity, page }),
    queryKey: [queryKey, entity, page],
    enabled: hasPermissions && !!entity.id,
  })

  const onChangePage = (page: Page) => {
    setPage(page)
  }

  return {
    onChangePage,
    data: data || initialData,
    isLoading: isFetching,
  }
}
